// /src/components/styles.js
// Shared CSS class utilities
export const cardCls = 'bg-[var(--card)] rounded-lg border border-[color:var(--border)]';
export const headingCls = 'font-bold text-[var(--text)]';
export const bodyText = 'text-[var(--text)]/90';
export const mutedText = 'text-[var(--muted)]';
export const ctaPrimary =
  'px-6 py-3 rounded-lg font-semibold inline-flex items-center gap-2 bg-[var(--accent)] text-white hover:opacity-90 transition';
export const ctaSecondary =
  'px-6 py-3 rounded-lg font-semibold inline-flex items-center gap-2 bg-[var(--bg)] text-[var(--accent)] border border-[color:var(--accent)] hover:bg-[var(--bg2)] transition';

// Shared layout utilities
export const pageHeading = 'font-mono text-base text-[var(--accent)] tracking-wider uppercase';
export const sectionLabel = 'font-mono text-xs text-[var(--accent)] tracking-wider uppercase';
export const pageWrap = '-mt-12 -mx-4';
export const sectionInner = 'max-w-7xl mx-auto px-4';